import { useEffect } from 'preact/hooks';

export function useVideoSlotPlayPause(playState: { isPlaying: boolean }, videoSlot: HTMLVideoElement) {
  useEffect(() => {
    const { isPlaying } = playState;
    if (isPlaying) {
      const p = videoSlot.play();
      p && p.catch(() => void 0);
    } else videoSlot.pause();
  }, [playState]);
}
